var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Row',{staticClass:"text-center"},[_c('i-col',{attrs:{"span":"24"}},[_c('Button',{attrs:{"type":"success","size":"large"},on:{"click":_vm.handleCreateAgreement}},[_vm._v("开始创建结算单")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }